import React from 'react';
import styles from './styles.module.scss';
import { BaseEditModal } from 'components';
import { Warning2Icon } from 'assets';
import { SalarySanityWarning } from 'utils/salary';

interface ConfirmSalaryModalProps {
  isOpen: boolean;
  warning: SalarySanityWarning | null;
  /** Return to the form with the salary field focused. */
  onEdit: () => void;
  /** Accept the figure as entered and carry on. */
  onContinue: () => void;
}

export const ConfirmSalaryModal: React.FC<ConfirmSalaryModalProps> = ({
  isOpen,
  warning,
  onEdit,
  onContinue,
}) => {
  if (!warning) return null;

  return (
    <BaseEditModal
      isOpen={isOpen}
      onClose={onEdit}
      title="Confirm Salary"
      onSubmit={onContinue}
      cancelButtonText="Edit Amount"
      saveButtonText="Continue Anyway"
      footerClassName={styles.footer}
      contentClassName={styles.modalContainer}
    >
      <div className={styles.modalContent}>
        <div className={styles.icon}>
          <Warning2Icon />
        </div>
        <h4 className={styles.header}>Confirm Expected Salary</h4>
        <p className={styles.text}>
          {warning.suggested ? (
            <>
              You entered <b>{warning.entered}</b>. Did you mean <b>{warning.suggested}</b> instead?
              If not, you can continue with the amount entered.
            </>
          ) : (
            <>
              You entered <b>{warning.entered}</b>. That is an unusually{' '}
              {warning.direction === 'low' ? 'small' : 'large'} amount — please double-check it.
              If it is correct, you can continue with the amount entered.
            </>
          )}
        </p>
      </div>
    </BaseEditModal>
  );
};
